import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Button, Stack, Tab, Typography } from "@mui/material";
import ReportScreen from "../../../../../common/enums/ReportScreens";
import ReportFiltersComponent from "../../ReportFiltersComponent";
import ReportFiltersLoading from "../../ReportFiltersLoading";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState, useEffect } from "react";
import { CustomerDatabaseStore } from "../../../../../store/main/CustomerDatabaseStore";
import { TerritoryDataStore } from "../../../../../store/main/TerritoryDataStore";
import ExecutiveSummaryBar from "../sub-component/ExecutiveSummaryBar";
import TopBottomExecutiveSummary from "../sub-component/TopBottomExecutiveSummary";
import DownloadIcon from "@mui/icons-material/Download";
import { ForceFieldType } from "../../../../../domain/models/executive-summary/force-field-type";
import ForceFieldTable from "./FieldForceTable";

const FieldForceDesktop = () => {
  const data: ForceFieldType[] = [
    {
      region_id: 1,
      region_name: "North1",
      areas: [
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      region_id: 2,
      region_name: "North2",
      areas: [
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      region_id: 3,
      region_name: "North3",
      areas: [
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      region_id: 4,
      region_name: "North4",
      areas: [
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi1",
          work_day: 24,
          coverage: 88,
          call_avg: 18,
          DEV: 132,
          abm_visits: 56,
          rbm_visits: 56,
          customers: [
            {
              customer_type_id: 1,
              customer_type_name: "stockist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 2,
              customer_type_name: "semi",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 3,
              customer_type_name: "retailer",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            {
              customer_type_id: 4,
              customer_type_name: "control chemist",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
            {
              customer_type_id: 5,
              customer_type_name: "healthcare provider",
              met: 1839,
              total_met: 2210,
              call_avg: 24.8,
              coverage: 23,
            },
          ],
          headquarters: [
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
            {
              hq_id: 1,
              hq_name: "Gurugram",
              work_day: 24,
              coverage: 88,
              call_avg: 18,
              DEV: 132,
              abm_visits: 56,
              rbm_visits: 56,
              customers: [
                {
                  customer_type_id: 1,
                  customer_type_name: "stockist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 2,
                  customer_type_name: "semi",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 3,
                  customer_type_name: "retailer",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                  invoices: 74500,
                  invoices_count: 73,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                {
                  customer_type_id: 4,
                  customer_type_name: "control chemist",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
                {
                  customer_type_id: 5,
                  customer_type_name: "healthcare provider",
                  met: 1839,
                  total_met: 2210,
                  call_avg: 24.8,
                  coverage: 23,
                },
              ],
            },
          ],
        },
      ],
    },
  ];
  const { userDetails, userRole, decodeToken, downloadExcelTable } =
    CustomerDatabaseStore();
  const { fetchCustomerTypes } = TerritoryDataStore();
  const [value, setValue] = useState<string>(data[0].region_name);
  const [topBottom, setTopBottom] = useState<boolean>(false);
  const [expandAll, setExpandAll] = useState<boolean>(false);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const [downloadJSON, setDownloadJSON] = useState([]);
  useEffect(() => {
    decodeToken();
    fetchCustomerTypes();
  }, []);
  useEffect(() => {
    setDownloadJSON([]);
  }, [topBottom, expandAll]);

  const downloadExcel = () => {
   
    // if (downloadJSON.length !== 0) downloadExcelTable(downloadJSON);
  };

  const filterData = () => {};
  const clearData = () => {};
  return (
    <>
      <Stack paddingY={2}>
        {Object.keys(userDetails).length > 0 ? (
          <ReportFiltersComponent
            type={ReportScreen.EXECUTIVE_SUMMARY}
            successCallback={filterData}
            clearSuccessCallBack={clearData}
            userRole={userRole.role}
            userDetails={userDetails}
            gridColumns={14}
            territoryMultiSelect={false}
          />
        ) : (
          <ReportFiltersLoading />
        )}
      </Stack>
      <ExecutiveSummaryBar />
      <Stack direction={"row"} gap={1} py={2}>
        <Button
          sx={{
            background:
              "linear-gradient(to bottom, rgb(120, 168, 242) 1%, rgb(64, 133, 237) 99%)",
            color: "white",
          }}
          onClick={() => {
            setTopBottom(!topBottom);
          }}
        >
          SEE TOP 50
        </Button>
        <Button
          sx={{
            background:
              "linear-gradient(to bottom, rgb(242, 122, 122) 1%, rgb(237, 64, 64) 99%)",
            color: "white",
          }}
          onClick={() => {
            setTopBottom(!topBottom);
          }}
        >
          SEE BOTTOM 50
        </Button>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={downloadExcel}
        >
          Download
        </Button>
        {!topBottom && (
          <Button
            sx={{ minWidth: 150 }}
            variant="contained"
            onClick={() => {
              setExpandAll(!expandAll);
            }}
            startIcon={
              !expandAll ? (
                <KeyboardArrowDownIcon fontSize="small" />
              ) : (
                <KeyboardArrowUpIcon fontSize="small" />
              )
            }
          >
            {!expandAll ? "Expand All" : "Close All"}
          </Button>
        )}
      </Stack>

      {topBottom ? (
        <TopBottomExecutiveSummary downloadJSON={downloadJSON} />
      ) : (
        <>
          {expandAll ? (
            <Stack gap={3}>
              {data.map((region) => (
                <Stack gap={2}>
                  <Typography variant="h6" fontWeight={600}>
                    {region.region_name}
                  </Typography>
                  <ForceFieldTable data={region.areas} />
                </Stack>
              ))}
            </Stack>
          ) : (
            <>
              <Stack>
                <TabContext value={value}>
                  <TabList onChange={handleChange}>
                    {data.map((region) => (
                      <Tab
                        label={region.region_name}
                        value={region.region_name}
                      />
                    ))}
                  </TabList>
                  {data.map((region) => (
                    <TabPanel value={region.region_name}>
                      <ForceFieldTable data={region.areas} />
                    </TabPanel>
                  ))}
                </TabContext>
              </Stack>
            </>
          )}
        </>
      )}
    </>
  );
};

export default FieldForceDesktop;
